export default __webpack_public_path__ + "static/prism-dd39485203336012caa43f665c024fe9.png";